import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function useCantinaInventario() {
  const [productos, setProductos] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const cargar = useCallback(async (q = '') => {
    try {
      setCargando(true);
      setError('');

      const response = await api.get('/cantina/productos', {
        params: q.trim() ? { q: q.trim() } : {},
      });

      setProductos(
        Array.isArray(response.data) ? response.data : []
      );
    } catch (err) {
      console.error('Error cargando inventario Cantina:', err);

      setProductos([]);
      setError(
        err?.response?.data?.error ||
          'No se pudieron cargar los productos.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      cargar(busqueda);
    }, 180);

    return () => clearTimeout(timer);
  }, [busqueda, cargar]);

  const ejecutar = async (fn) => {
    try {
      setGuardando(true);
      setError('');

      const response = await fn();

      await cargar(busqueda);

      return {
        ok: true,
        data: response.data,
      };
    } catch (err) {
      console.error('Error modificando inventario Cantina:', err);

      const mensaje =
        err?.response?.data?.error ||
        'No se pudo completar la operación.';

      setError(mensaje);

      return {
        ok: false,
        error: mensaje,
      };
    } finally {
      setGuardando(false);
    }
  };

  const crearProducto = (data) =>
    ejecutar(() =>
      api.post('/cantina/productos', data)
    );

  const editarProducto = (id, data) =>
    ejecutar(() =>
      api.put(`/cantina/productos/${id}`, data)
    );

  const reponerStock = (id, data) =>
    ejecutar(() =>
      api.post(`/cantina/productos/${id}/reposicion`, data)
    );

  const ajustarStock = (id, data) =>
    ejecutar(() =>
      api.post(`/cantina/productos/${id}/ajuste`, data)
    );

  const recargar = () => cargar(busqueda);

  return {
    productos,
    busqueda,
    setBusqueda,
    cargando,
    guardando,
    error,
    setError,
    recargar,
    crearProducto,
    editarProducto,
    reponerStock,
    ajustarStock,
  };
}
